<template>
  <v-container v-if="$mq.md_sm || collapsed" fluid class="bg-white" :class="$mq.md_sm ? 'px3' : 'px2' ">
    <MenuList horizontal>
      <button @click.prevent="collapsed = !collapsed">
        <v-icon>expand_more</v-icon>
      </button>
    </MenuList>
  </v-container>

  <v-layout v-else column>
    <button @click.prevent="collapsed = !collapsed" class="close-btn my0 absolute" >
      <v-icon>expand_less</v-icon>
    </button>

    <MenuList vertical group="1" class="topbarmenu-list-override"/>
    <v-divider />
    <MenuList vertical group="2" class="topbarmenu-list-override pb-0" />
  </v-layout>
</template>



<script>
/* @flow */
import MenuList from './MenuList'
import icons from '../icons'

export default {
  name: 'TopbarMenu',
  data() {
    return {
      collapsed: true,
      ...icons,
    }
  },
  watch: {
    $route() {
      this.collapsed = true
    },
  },
  components: {
    MenuList,
  },
}
</script>



<style scoped>
.container {
  padding-top: 12px;
  padding-bottom: 12px;
}

.close-btn {
  right: 6px;
  top: 2px;
  height: 44px;
  width: 44px;
  z-index: 100;
}

button {
  margin: 0 -2px;
}
</style>


<style>
.topbarmenu-list-override .list__tile {
  padding-left: 16px;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/TopbarMenu.vue